import React from 'react';

import { FormInput } from '@/components/shared/Inputs';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { useDeleteMyUserMutation } from '@/graphql';
import { FetchError } from '@/graphql/codegen-fetcher';
import { useAuth } from '@/providers/AuthProvider';
import { FormHelperText } from '@material-ui/core';
import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';

import { AccountDisplayProps } from '../../AccountPanel';
import styles from './DeleteAccountVerify.module.scss';

const validationSchema = Yup.object().shape({
	code: Yup.string().required('Please enter your code'),
});

export const DeleteAccountVerify: React.FC<AccountDisplayProps> = () => {
	const { enqueueSnackbar } = useSnackbar();
	const { mutateAsync, error: deleteError } =
		useDeleteMyUserMutation<FetchError>();
	const { user, logout } = useAuth();

	return (
		<Formik
			initialValues={{
				code: '',
			}}
			validationSchema={validationSchema}
			onSubmit={async (values, formikHelpers) => {
				if (values.code.length < 4) {
					return formikHelpers.setFieldError('code', 'Invalid code');
				}
				try {
					await mutateAsync({ code: values.code });
					enqueueSnackbar('Successfully deleted user', {
						variant: 'success',
					});
					logout({
						noSnackbar: true,
					});
				} catch (error) {
					return console.log(`Error deleting user`, error);
				}
			}}
		>
			{({
				handleSubmit,
				handleChange,
				setFieldValue,
				values,
				isSubmitting,
				errors,
			}) => (
				<SingleActionLayout
					actionLabel="Permenantly delete account"
					actionClassName={styles['delete-account__button']}
					actionDisabled={isSubmitting}
					onActionClick={handleSubmit}
				>
					<form onSubmit={handleSubmit} className="text-center">
						<div className="px-md">
							Enter the verification code sent to {user.email}
						</div>
						<div className="vsb-20" />

						<FormInput
							id="code"
							name="code"
							type="code"
							placeholder="1234"
							onChange={handleChange}
							value={values.code}
							className={styles['delete-account__input']}
						/>
						<div
							style={{
								visibility:
									errors.code || deleteError
										? 'visible'
										: 'hidden',
							}}
						>
							<FormHelperText
								error={true}
								className="text-center"
							>
								{errors.code ||
									deleteError?.message ||
									'Placeholder'}
							</FormHelperText>
						</div>
						<div className="vsb-20" />

						<div className={`${styles['delete-account__warning']}`}>
							Account deletion is permenent and CANNOT be
							restored. Please proceed with CAUTION.
						</div>
					</form>
				</SingleActionLayout>
			)}
		</Formik>
	);
};
